import cards from './cards'
import {spreadActions, spreadLayout} from './spreadSettings'

export default {
    cards, spreadActions, spreadLayout,
    screenSize: null,
    firstPage: null,
    lastPage: null,
    hasSeenIntro: false,
}